import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { ConfigurableOptionComponent } from "./configurable-options.component";
import { CreateConfigurableOptionComponent } from "./create-configurable-option/create-configurable-option.component";
import { ManageConfigurableOptionComponent } from "./manage-configurable-option/manage-configurable-option.component";

@NgModule({
  declarations: [CreateConfigurableOptionComponent, ManageConfigurableOptionComponent, ConfigurableOptionComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateConfigurableOptionComponent, ManageConfigurableOptionComponent, ConfigurableOptionComponent],
})
export class ConfigurableOptionModule {}
